<app-stages [stages]="stages" currentStage="Informacja publiczna">
</app-stages>
<br>
@if (!pending() && !loading()) {
  <form autocomplete="off" novalidate [formGroup]="form" (ngSubmit)="submitAndGoNext()">
    <div class="row">
      <div class='col-md-6'>
        <div class='form-group' *ngIf='"informationDisclosureMethod" as controlName'>
          <label [for]='controlName'>
            Sposób i forma udostępnienia oraz przekazania informacji *
          </label>
          <select
            (change)="form.informationDisclosureMethodChange(form.getElement($event).value)"
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'>
            <option value=''>Wybierz</option>
            <option value='Dostęp do przeglądania informacji w siedzibie Starostwa'>
              Dostęp do przeglądania informacji w siedzibie Starostwa
            </option>
            <option value='Kserokopia – odbiór osobisty w siedzibie Starostwa'>
              Kserokopia – odbiór osobisty w siedzibie Starostwa
            </option>
            <option value='Kserokopia – przesłanie pocztą na podany powyżej adres do korespondencji'>
              Kserokopia – przesłanie pocztą na podany powyżej adres do korespondencji
            </option>
            <option value='Przesłanie informacji pocztą elektroniczną na podany powyżej adres e-mail'>
              Przesłanie informacji pocztą elektroniczną na podany powyżej adres e-mail
            </option>
            <option value='Pliki na płycie CD/DVD – przesłanie pocztą na podany powyżej adres do korespondencji'>
              Pliki na płycie CD/DVD – przesłanie pocztą na podany powyżej adres do korespondencji
            </option>
            <option value="Pliki na płycie CD/DVD – odbiór osobisty w siedzibie Starostwa">
              Pliki na płycie CD/DVD – odbiór osobisty w siedzibie Starostwa
            </option>
            <option value='W inny sposób'>
              W inny sposób
            </option>
          </select>
          <app-validation-errors [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      @if (form.additionalInformation) {
        <div class='col-12'>
          <div class='form-group' *ngIf='"additionalInformation" as controlName'>
            <label [for]='controlName'>
              Inny sposób i forma *
            </label>
            <textarea
              rows="5"
              [id]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              [formControlName]='controlName'
              placeholder='Opisz tu inny sposób i formę przekazania danych'></textarea>
            <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      }
      <div class='col-12'>
        <div class='form-group' *ngIf='"description" as controlName'>
          <label [for]='controlName'>
            Udostępnienie informacji publicznej dotyczy *
          </label>
          <textarea
            rows="5"
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu czego dotyczy udostępnienie informacji'></textarea>
          <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
      <div class='col-12'>
        <div class='form-group' *ngIf='"publicInformationDisclosureJustification" as controlName'>
          <label [for]='controlName'>
            Uzasadnienie udostępnienia informacji publicznej *
          </label>
          <textarea
            rows="5"
            [id]='controlName'
            [ngClass]='{ "is-invalid": form.showError(controlName) }'
            [formControlName]='controlName'
            placeholder='Wpisz tu uzasadnienie'></textarea>
          <app-validation-errors [showTextLength]="true" [control]='form.get(controlName)'>
          </app-validation-errors>
        </div>
      </div>
    </div>
  </form>
  <div class='application-actions'>
    <button
      [disabled]="pending()"
      (click)="onCancel()"
      type='button'
      class='btn btn-secondary'>
        <span>
          Wstecz
        </span>
    </button>
    <button
      (click)="submitAndGoNext()"
      [disabled]="pending()"
      type='button'
      class='btn btn-primary'>
      <span>Zapisz i przejdź dalej</span>
    </button>
  </div>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
